import {
  progress_dots_styles_default
} from "./chunk.4MHI4JEP.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/progress-dots/progress-dots.ts
import { t } from "i18next";
var id = 0;
var FadvProgressDots = class extends s {
  constructor() {
    super(...arguments);
    this.componentId = `progress-dots-${++id}`;
  }
  get dots() {
    var _a;
    const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("slot");
    const slotted = slot == null ? void 0 : slot.assignedElements();
    return slotted == null ? void 0 : slotted.filter((e2) => hasTag(e2, "fadv-progress-dot")).map((e2) => e2);
  }
  handleDotActivation(event) {
    var _a;
    (_a = this.dots) == null ? void 0 : _a.filter((d) => d.value !== event.detail.value).forEach((d) => d.active = false);
    this.activeDot = event.detail.value;
    emit(this, "progress-dots-active-change", { detail: { activeDot: this.activeDot } });
  }
  handleActiveDotChange() {
    var _a;
    (_a = this.dots) == null ? void 0 : _a.forEach((d) => {
      if (d.value === this.activeDot) {
        d.active = true;
      }
    });
  }
  firstUpdated() {
    this.updateComplete.then(() => {
      var _a;
      if (this.activeDot) {
        this.handleActiveDotChange();
      } else if ((_a = this.dots) == null ? void 0 : _a.length) {
        const firstDot = this.dots[0];
        firstDot.active = true;
        this.activeDot = firstDot.value;
      }
    });
  }
  handleKeyDown(event) {
    var _a;
    const target = event.target;
    const progressDot = target.closest("fadv-progress-dot");
    if (["Enter", " "].includes(event.key)) {
      if (progressDot !== null) {
        progressDot.active = true;
      }
      event.preventDefault();
    }
    if (!((_a = this.dots) == null ? void 0 : _a.length))
      return;
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
      const activeEl = document.activeElement;
      if (hasTag(activeEl, "fadv-progress-dot")) {
        let index = this.dots.indexOf(activeEl);
        if (event.key === "Home") {
          index = 0;
        } else if (event.key === "End") {
          index = this.dots.length - 1;
        } else if (event.key === "ArrowLeft") {
          index = Math.max(0, index - 1);
        } else if (event.key === "ArrowRight") {
          index = Math.min(this.dots.length - 1, index + 1);
        }
        const nextProgressDot = this.dots[index];
        nextProgressDot.focus();
        event.preventDefault();
      }
    }
  }
  render() {
    return $`<div id=${this.componentId} role="tablist" aria-label=${this.label ? this.label : t("components:progressDots.progressDots")} class="progress-dots" @progress-dot-activated=${this.handleDotActivation} @keydown=${this.handleKeyDown} ><slot></slot></div>`;
  }
};
FadvProgressDots.styles = progress_dots_styles_default;
__decorateClass([
  e({ reflect: true, attribute: "active-dot" })
], FadvProgressDots.prototype, "activeDot", 2);
__decorateClass([
  e()
], FadvProgressDots.prototype, "label", 2);
__decorateClass([
  watch("activeDot")
], FadvProgressDots.prototype, "handleActiveDotChange", 1);
FadvProgressDots = __decorateClass([
  n("fadv-progress-dots")
], FadvProgressDots);

export {
  FadvProgressDots
};
